module.exports = __webpack_public_path__ + "static/img/incheon-paralympic-pt.8a3627a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/incheon-paralympic-pt.jpg
// module id = ytiH
// module chunks = 0